export function getTaskIdFromStepId(stepId) {
    return stepId.toString().split("-")[0]
}
